import type { ApiProyectoFull } from "@/@types/Api_Extracted";
import pie from "./pie.svg";

export function ResumenProyecto(props: { readonly proyecto: ApiProyectoFull; }) {
	return (
		<div>
			<h2 className="text-lg font-bold">14,82 kgCO₂e/unidad</h2>
			<div className="mt-2 flex justify-between gap-2">
				<ul className="list-disc ml-5">
					<li>Materias primas: 42 %</li>
					<li>Procesos intermedios: 18 %</li>
					<li>Fabricación propia: 21 %</li>
					<li>Transportes: 6 %</li>
					<li>Embalaje: 5 %</li>
					<li>Residuos: 3 %</li>
					<li>Downstream: 5 %</li>
				</ul>
				<img src={pie} alt="Resumen gráfico" style={{ maxWidth: "600px" }} />
			</div>
		</div>
	);
}
